<template>
  <div class="edCertificate">
    <div class="newCertificate flex_ac" @click="tonewCertificate">
      <div class="Certificate-title">
        新证书查询
        <img
          src="../../assets/image/edcertificate/jiantou-right.png"
          style="width: 18px;height: 18px;margin-left: 8px;"
          alt=""
        />
      </div>
      <div class="Certificate-info">2026年1月1日后的活动在此查询证书</div>
    </div>
    <div class="oldCertificate flex_ac" @click="tooldCertificate">
      <div class="Certificate-title">
        旧证书查询
        <img
          src="../../assets/image/edcertificate/jiantou-right.png"
          style="width: 18px;height: 18px;margin-left: 8px;"
          alt=""
        />
      </div>
      <div class="Certificate-info">2026年1月1日前的活动在此查询证书</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  components: {},

  methods: {
    tonewCertificate() {
      this.$router.push({
        path: '/newCertificate'
      })
    },
    tooldCertificate() {
      this.$router.push({
        path: '/oldCertificate'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edCertificate {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  padding: 28px 16px 0 16px;
  .newCertificate {
    width: 100%;
    height: 120px;
    background-image: url('../../assets/image/edcertificate/newCertificate.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 0 20px;
    .Certificate-title {
      display: flex;
      font-size: 18px;
      color: #ffffff;
      font-weight: 600;
      margin-bottom: 10px;
      align-items: center;
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    }
    .Certificate-info {
      color: #ffffff;
      font-size: 14px;
    }
  }
  .oldCertificate {
    width: 100%;
    height: 120px;
    background-image: url('../../assets/image/edcertificate/oldCertificate.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 0 20px;
    margin-top: 28px;
    .Certificate-title {
      display: flex;
      font-size: 18px;
      color: #ffffff;
      font-weight: 600;
      margin-bottom: 10px;
      align-items: center;
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    }
    .Certificate-info {
      color: #ffffff;
      font-size: 14px;
    }
  }
  .flex_ac {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
